import React from "react";

import { useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";
import TableReact from "../../components/table/Table";
import { formatDate, formatDateTime } from "../../helper/formatter.js";
import _ from "lodash";

const Usuarios = () => {
    const usuarios = useSelector((state) => state.usuarios.items);

    const columns = React.useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                Cell: ({ row }) => (
                    <Link to={"/usuario/" + row.original?.id} className="fw-bold text-nowrap">
                        ID-{row.original?.id}
                    </Link>
                ),
                canGroupBy: false,
            },
            {
                Header: "Nombre",
                accessor: "name",
                canGroupBy: false,
            },
            {
                Header: "Email",
                accessor: "email",
                canGroupBy: false,
            },

            {
                Header: "Fecha Ultimo ingreso",
                accessor: "lastvisitdate",
                Cell: ({ row }) => <div className="text-nowrap">{formatDateTime(row.original?.lastvisitdate)}</div>,
                canGroupBy: false,
            },
            {
                Header: "Ult. Modificacion",
                accessor: "updatedAt",
                Cell: ({ row }) => <div className="text-nowrap">{formatDateTime(row.original?.updatedAt)}</div>,
                canGroupBy: false,
            },
            {
                Header: "Fecha de registro",
                accessor: "createdAt",
                Cell: ({ row }) => <div className="text-nowrap">{formatDate(row.original?.createdAt)}</div>,
                canGroupBy: false,
            },
        ],
        []
    );

    const data = React.useMemo(
        () =>
            _(usuarios)
                .reject((v) => v.id == 1)
                .value(),
        [usuarios]
    );

    return (
        <Panel>
            <PanelHeader>Listado de usuarios registrados</PanelHeader>
            <PanelBody>
                <div className="d-flex flex-wrap">
                    <Link type="button" className="btn btn-green me-1 mb-1" to={"/usuario"}>
                        <i className="fa fa-plus fa-fw"></i> Agregar nuevo usuario
                    </Link>
                </div>
            </PanelBody>
            <TableReact columns={columns} data={data} selection={false} />
        </Panel>
    );
};

export default Usuarios;
